import React from 'react';

import { Button, Image, UIHeading2, UIHeading4, UIText1, UIText2 } from '@cian/ui-kit';

import { formatNumberWithSpaces, transformNumToString, trimToDecimals } from '../../../common/utils';

import { NBSP, PERCENT, RUB } from '../../../common/constants';
import { ETestIds } from '../../constants';
import { IOfferCardProps } from '../OfferCard';
import { LabelComponent } from '../OfferCard/components/LabelComponent';

import * as styles from './styles.css';

export const OfferCardMobile: React.FC<IOfferCardProps> = ({ offer, onClick }) => {
  const { offerName, iconPath, offerDescription, label, rate, monthlyPayment, type } = offer;

  return (
    <div className={styles['card']} data-testid={`${ETestIds.OfferCard} ${ETestIds.OfferCard}-${type}`}>
      <div className={styles['card__heading']}>
        <div className={styles['card__title']}>
          <div>
            <UIHeading2>{offerName}</UIHeading2>
            <UIText1>{offerDescription}</UIText1>
          </div>
          <div className={styles['card__title-icon']}>
            <Image src={iconPath} borderRadius={'50%'} title={offerName} alt={offerName} preloader />
          </div>
        </div>
        <LabelComponent text={label} />
      </div>
      <div className={styles['card__details']}>
        <div className={styles['card__details-item']}>
          <UIText2 color={'text-secondary-default'}>Ставка</UIText2>
          <UIHeading4 color={'text-primary-default'}>
            {transformNumToString(trimToDecimals(Number(rate))) + PERCENT}
          </UIHeading4>
        </div>
        <div className={styles['card__details-item']}>
          <UIText2 color={'text-secondary-default'}>Платёж</UIText2>
          <UIHeading4 color={'text-primary-default'}>
            {'от' + NBSP + formatNumberWithSpaces(monthlyPayment) + NBSP + RUB}
          </UIHeading4>
        </div>
      </div>
      <Button size="M" theme={'fill_secondary'} onClick={onClick} fullWidth>
        Подробнее
      </Button>
    </div>
  );
};
